import { useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';
import { useLanguage } from '../context/LanguageContext';
import { t } from '../lib/translations';
import { LanguageSelector } from '../components/LanguageSelector';

export function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');
  const { language } = useLanguage();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus('loading');
    setMessage('');

    try {
      await api.forgotPassword(email, language);
      setStatus('success');
      setMessage(t('resetEmailSent', language));
    } catch (err: any) {
      setStatus('error');
      setMessage(err.message || t('resetEmailFailed', language));
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div style={{ position: 'absolute', top: '1rem', left: '1rem' }}>
        <Link to="/login" style={{ color: 'var(--primary)', fontWeight: 600, textDecoration: 'none' }}>
          ← {t('backToLogin', language)}
        </Link>
      </div>
      <div style={{ position: 'absolute', top: '1rem', right: '1rem' }}>
        <LanguageSelector />
      </div>
      <div className="card card-large w-full max-w-md fade-in">
        <div className="text-center mb-8">
          <h1 className="text-3xl mb-2" style={{ color: 'var(--primary)' }}>
            MindsetFamily
          </h1>
          <p className="text-gray-600">{t('forgotPasswordSubtitle', language)}</p>
        </div>

        {status === 'success' ? (
          <div className="text-center py-8">
            <span className="text-5xl block mb-4">📧</span>
            <h2 className="text-xl font-semibold text-green-700 mb-2">{t('checkYourEmail', language)}</h2>
            <p className="text-gray-600 mb-6">{message}</p>
            <Link to="/login" className="btn btn-primary">
              {t('backToLogin', language)}
            </Link>
          </div>
        ) : (
          <>
            {status === 'error' && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-4">
                {message}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div className="mb-6">
                <label className="label">{t('email', language)}</label>
                <input
                  type="email"
                  className="input"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="parent@example.com"
                  required
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-large w-full"
                disabled={status === 'loading'}
              >
                {status === 'loading' ? t('loading', language) : t('sendResetLink', language)}
              </button>
            </form>

            <p className="text-center mt-6 text-gray-600">
              {t('rememberedPassword', language)}{' '}
              <Link to="/login" className="text-primary font-semibold" style={{ color: 'var(--primary)' }}>
                {t('login', language)}
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
